import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import PilotFaq from "../pilot-faq";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiFaqClick } from "../../../constants/tracking-constants/pre-delivery-inspection";

const PreDeliveryInspectionFaqs = ({ details}) => {
    const {
        title: faqTitle = "",
        sectionData: faqList = []
    } = details || {};

    const accordionClickHandler = async (id) => {
        await yieldToMain();
        sendCustomGaEvents({ ...pdiFaqClick, eventLabel: id });
    };

    return (
        <div styleName={"styles.faqMainWrapper"}>
            <div styleName={"styles.faqWrapper"}>
                {
                    faqList?.length > 0 &&
                <>
                    <PilotFaq
                        heading={faqTitle}
                        faqs={faqList}
                        attachSchema={true}
                        accordionClickHandler={accordionClickHandler}
                        hasListElements={true}
                    />
                </>
                }

            </div>
        </div>

    );
};

PreDeliveryInspectionFaqs.propTypes = {
    details: PropTypes.object
};

export default PreDeliveryInspectionFaqs;
